import { render, staticRenderFns } from "./CourseItem.vue?vue&type=template&id=b275696c&scoped=true"
import script from "./CourseItem.vue?vue&type=script&lang=ts"
export * from "./CourseItem.vue?vue&type=script&lang=ts"
import style0 from "./CourseItem.vue?vue&type=style&index=0&id=b275696c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b275696c",
  null
  
)

export default component.exports